import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import { store } from "./store"
import { router } from "./router"
import firebase from "firebase/app";
import "firebase/auth";

Vue.config.productionTip = false

const configOptions = {
  apiKey: "AIzaSyBiaVqYv5QQOO9MGY4AGe4Eog5-dl3jXvM",
  authDomain: "promect-30.firebaseapp.com",
  databaseURL: "https://promect-30.firebaseio.com",
  projectId: "promect-30",
  storageBucket: "",
  messagingSenderId: "",
  appId: ""
};

firebase.initializeApp(configOptions);

let app;

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  if (user) {
    store.commit("login", user);
    if (router.currentRoute.name === 'login')
      router.replace('/');
  } else {
    store.commit("logout");
    if (router.currentRoute.name !== "login")
        // eslint-disable-next-line no-unused-vars
      router.replace("/login").catch(err => {});
  }
});


